/**
 * Cursor state palette for Data Vault chart interactions.
 *
 * Centralizes the OS-level cursor names used across chart hooks so the
 * library speaks one vocabulary about "this is grabable" / "this is
 * draggable" / "drag this edge to resize."
 *
 * Note: this is the *OS* cursor. The custom SVG hand pointer that follows
 * the cursor on chart hover is rendered separately (see useChartPointer
 * once it lands — currently still useChartCrosshair, rename pending).
 */

export const CURSOR = {
  /** Default — no special affordance. */
  default: 'default',
  /** Pointing-hand — interactive element (button, link, clickable point). */
  pointer: 'pointer',
  /** Open hand — pan-mode armed, hovering pannable area. */
  grab: 'grab',
  /** Closed hand — actively dragging to pan. */
  grabbing: 'grabbing',
  /** Vertical resize — south edge of ChartShell. */
  resizeNS: 'ns-resize',
  /** Horizontal resize — y-axis-edge drag in `useAxisScale`. */
  resizeEW: 'ew-resize',
  /** Diagonal resize — SE corner of ChartShell. */
  resizeNWSE: 'nwse-resize',
  /** Crosshair — used by brush mode while dragging out a region. */
  crosshair: 'crosshair',
  /** Not allowed — disabled chart areas. */
  notAllowed: 'not-allowed',
} as const;

export type CursorName = keyof typeof CURSOR;
export type CursorValue = (typeof CURSOR)[CursorName];
